<template>
  <div
    v-if="filtersToDisplay.length"
    ref="filtersContainer"
    :class="$style.appliedFiltersContainer"
  >
    <template v-for="filter in filtersToDisplay">
      <Pill
        v-if="filter.type && filter.displayValue"
        :key="filter.type"
        :class="$style.pill"
        :handleDeleteButtonClick="() => handleDeleteButtonClick(filter)"
        :showDeleteButton="true"
        :text="getFilterText(filter)"
      />
    </template>
  </div>
</template>

<script>
import { extend } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import Pill from 'client/components/Buttons/Pill.vue';

export default {
  name: 'AppliedFilters',

  components: {
    Pill,
  },

  props: {
    searchFetch: {
      type: Function,
      required: true,
    },
    setInputPadding: {
      type: Function,
      required: true,
    },
    storeModule: {
      type: String,
      required: true,
    },
  },

  computed: {
    filtersToDisplay() {
      // There may be multiple objects for a single filter. Only display one for each filter
      const filters = [];
      this.filters.forEach((filter) => {
        const existingFilter = filters.find(f => (
          f.type === filter.type && f.displayValue === filter.displayValue
        ));
        if (!existingFilter) {
          filters.push(filter);
        }
      });
      return filters;
    },
  },

  beforeCreate() {
    this.$options.computed = {
      ...this.$options.computed,
      ...mapGetters(this.$options.propsData.storeModule, {
        filters: 'getAppliedFilters',
      }),
    };

    extend(
      this.$options.methods,
      mapActions(this.$options.propsData.storeModule, [
        'deleteFilter',
      ]),
    );
  },

  updated() {
    if (this.$refs.filtersContainer) {
      const { clientWidth } = this.$refs.filtersContainer;
      this.setInputPadding(clientWidth);
    } else {
      this.setInputPadding(0);
    }
  },

  methods: {
    getFilterText(filter) {
      return `${filter.type} : ${filter.displayValue}`;
    },

    handleDeleteButtonClick(filter) {
      this.deleteFilter({ filterName: filter.name });
      this.searchFetch();
    },
  },
};
</script>
<style scoped module>
.appliedFiltersContainer {
  align-items: center;
  display: flex;
  height: 100%;
  left: 32px;
  max-width: calc(100% - 32px);
  overflow-x: hidden;
  position: absolute;
  top: 0;
}

.pill {
  margin-right: 5px;
}
</style>
